<template>
  <div class="recharge">
    <div class="content">
      <div class="card">
        <div class="user">
          <div class="title">账户可用余额（元）</div>
          <div class="handle">
            <div class="num">{{balance}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block"></div>
    <Form class="form" label-position="top">
      <FormItem label="充值金额">
        <Input class="input" placeholder="请输入充值金额" v-model="formItem.money"></Input>
      </FormItem>
      <FormItem label="充值方式">
        <tabNav :list="payTypeList" v-model="formItem.method"></tabNav>
      </FormItem>
      <div class="footer">
        <div class="total">应付金额: ￥{{formItem.money}}</div>
        <Button class="pay-btn" type="primary" @click="payment()" style="width: 100px">立即支付</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import tabNav from '../../components/tabNav'
import paymentAlert from '../../components/payment-alert'

export default {
  name: 'setting',
  components: {
    tabNav
  },
  data () {
    return {
      balance: 0,
      timer: null,
      page: 'platform',
      formItem: {
        method: 3,
        money: ''
      },
      payTypeList: [

        {
          value: 3,
          label: '微信支付'
        },
        {
          value: 2,
          label: '支付宝支付'
        }
      ]
    }
  },
  created () {
    let vm = this
    vm.init()
  },
  methods: {
    init () {
      let vm = this
      this.$store.dispatch('getUserInfo').then(res => {
        vm.balance = res.balance
      })
    },
    payment () {
      if (!this.formItem.money) {
        return this.$message.error('请输入金额')
      }
      if (this.formItem.money <= 0) {
        return this.$message.error('金额必须大于0')
      }
      let vm = this
      if (vm.formItem.method == '3') {
        // 微信支付
        this.$request('610b85a03b26b', {
          'money': vm.formItem.money,
          'method': vm.formItem.method.toString()
        }).then(res => {
          let aaa = this.$paymentAlert({
            title: '扫码支付',
            code_url: res.data.data.config.code_url,
            text: '充值'
          }).then(ress => {
            console.log(ress, '结果')
            if (ress == 'cancel') {
              clearInterval(vm.timer)
            }
          })
          this.timer = setInterval(() => {
            this.$request('619f23ac0f0d0', {
              'order_no': res.data.data.order_number,
              'scene': 'recharge'
            }).then(resp => {
              if (resp.data.data.status == '1') {
                clearInterval(vm.timer)
                this.$message.success('充值成功')
                location.reload()
              }
            })
          }, 2000)
        })
      } else {
        let userInfo = localStorage.getItem('USERINFO')
        let user_id = JSON.parse(userInfo).id
        // 支付宝支付
        window.open('https://api.yibxj.com/api/rechargeByAlipay?money=' + vm.formItem.money + '&user_id=' + user_id, '_blank')
        setTimeout(() => {
          this.$confirm('确定支付成功了吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.go(-1)
          }).catch(() => {

          })
        }, 1000)
      }
    },
    clickDetail () {
      console.log(123)
    }
  }
}
</script>

<style lang="less">
  .recharge {
    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      background-color: #FFFFFF;
    }

    .card {
      display: flex;
      justify-content: space-between;
      padding: 20px 10px;

      .user {
        min-width: 300px;
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 18px;
          color: #333;
          font-weight: 700;
        }

        .handle {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .num {
            font-size: 24px;
            color: #333;
          }

          .btn-view {
            margin-left: 60px;

            .recharge {
              margin-right: 10px;
            }
          }
        }
      }

      .total {
        display: flex;
        align-items: center;

        .total-item {
          width: 120px;

          .title {
            font-size: 12px;
            color: rgb(102, 102, 102);
            letter-spacing: 0;
            line-height: 1;
          }

          .num {
            font-size: 28px;
            color: rgb(17, 17, 17);
            letter-spacing: 0;
            line-height: 1;
            margin-top: 10px;
          }
        }
      }

    }

    .block {
      width: 100%;
      height: 15px;
      background-color: #f7f8fa;
    }

    .form {
      padding-left: 10px;
      margin-top: 30px;

      .input {
        width: 300px;
      }

      .tips {
        color: #999999;
        font-size: 12px;
        margin-bottom: 30px;
      }

      .footer {
        display: flex;
        align-items: center;
        margin-top: 30px;
        margin-bottom: 20px;

        .pay-btn {
          margin-left: 30px;
        }
      }
    }

  }
</style>
